/* eslint-disable */
const Footer = {
  init: function () {
    const self = this;
    this.handleScroll();
    window.addEventListener("scroll", function () {
      self.handleScroll()
    });
  },

  initMap: function () {
    const footerMap = document.getElementById("footerMap");
    if (!footerMap) return;

    const centerLat = parseFloat(footerMap.dataset.centerLat);
    const centerLng = parseFloat(footerMap.dataset.centerLng);
    const zoom = parseInt(footerMap.dataset.zoom);

    this.mapSettings(footerMap, centerLat, centerLng, zoom);
    footerMap.setAttribute("data-map-initialized", "true");
  },

  mapSettings: function (mapEl, centerLat, centerLng, zoom) {
    const mapOptions = {
      center: {lat: centerLat, lng: centerLng},
      zoom: zoom,
      styles: this.styles(),
    };

    const map = new google.maps.Map(mapEl, mapOptions);

    this.addMarkers(map, mapEl, centerLat, centerLng);
  },

  addMarkers: function (map, mapEl, centerLat, centerLng) {
    const markerUrl = mapEl.dataset.marker;
    const markersData = [
      {
        position: {lat: centerLat, lng: centerLng},
        icon: markerUrl,
      },
    ];

    markersData.forEach((markerData) => {
      const marker = new google.maps.Marker({
        position: markerData.position,
        map: map,
        icon: markerData.icon,
      });
      const address = mapEl.dataset.address;
      const data = `<a href="https://www.google.com/maps?q=${encodeURIComponent(address)}" target="_blank">${address}</a>`;
      let infowindow;
      if (data) {
        infowindow = new google.maps.InfoWindow({
          content: data
        });


        google.maps.event.addListener(marker, 'click', function () {
          infowindow.open(map, marker);
        });

        google.maps.event.addListener(map, 'click', function () {
          infowindow.close();
        });
      }
    });

  },

  styles: function () {
    return [
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#a7a7a7"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#737373"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#efefef"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#696969"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#b3b3b3"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#d6d6d6"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#ffffff"
          },
          {
            "weight": 1.8
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#d7d7d7"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
          {
            "color": "#808080"
          },
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#d3d3d3"
          }
        ]
      }
    ]
  },

  handleScroll: function () {
    const footer = document.querySelector('.footer');
    const footerMap = document.getElementById("footerMap");
    if (!footerMap) return;

    if (scrollToEl(footer) && !footerMap.hasAttribute("data-map-initialized")) {
      this.initMap();
    }

    function scrollToEl(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top <= (window.innerHeight || document.documentElement.clientHeight)
      );
    }
  },
}

export default Footer;
